import Vue from 'vue'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import App from './App.vue'
import router from './router'
import store from './store'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { createDateFilter } from "vue-date-fns";
import VueDateFns from "vue-date-fns";
import VueAnalytics from 'vue-analytics'
import IdleVue from 'idle-vue'
import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css"
import VueSignaturePad from 'vue-signature-pad';
import vmodal from 'vue-js-modal'
import fieldImageDisplay from "@/components/FieldImageDisplay.vue";
import fieldAttachments from "@/components/FieldAttachments.vue";

Vue.config.productionTip = false

const isProd = process.env.NODE_ENV === 'production'

Vue.use(VueAnalytics, {
  id: 'UA-138069741-2',
  router,
  autoTracking: {
    screenview: false,
    exception: true
  },
  debug: {
    enabled: false,
    sendHitTask: isProd
  }
})


Sentry.init({
  dsn: 'https://167bc7df8d9a4be187e6e94a7c1b6923@sentry.io/1886944',
  integrations: [new Integrations.Vue({Vue, attachProps: true, logError:true })],
  environment: process.env.VUE_APP_ENV
});

const idle_eventsHub = new Vue()
Vue.use(IdleVue, { eventEmitter: idle_eventsHub, idleTime: 600000 })

Vue.component('multiselect', Multiselect)
Vue.component("fieldImageDisplay", fieldImageDisplay);
Vue.component("fieldAttachments", fieldAttachments);
Vue.use(VueFormGenerator)
Vue.use(VueDateFns);
Vue.filter("date", createDateFilter("DD/MM/YYYY"));
Vue.filter('truncate', function (text, stop, clamp) {
  return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
})
Vue.use(VueSignaturePad);
Vue.use(vmodal)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
